import { ActionCenterTask } from '@domain'

import api from '.'

// Query Key factory
export const ActionCenterKeys = {
	tasks: (id: Id) => ['action-center-tasks', id],
}

const ActionCenterTasksApi = {
	tasks: (basketId: Id) =>
		api
			.get<APIRes<ActionCenterTask[]>>(`/market-baskets/${basketId}/tasks`)
			.then((res) => res.data.data),
}

export default ActionCenterTasksApi
